import type { IconProps } from './IconProps';

export const DisconnectIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M5.8125 8H14.5625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0625 4.5L14.5625 8L11.0625 11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.4375 14.5625H2.75C2.4019 14.5625 2.06806 14.4242 1.82192 14.1781C1.57578 13.9319 1.4375 13.5981 1.4375 13.25V2.75C1.4375 2.4019 1.57578 2.06806 1.82192 1.82192C2.06806 1.57578 2.4019 1.4375 2.75 1.4375H8.4375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
